module.exports = __webpack_public_path__ + "img/slide1.a35cb18b.png";